// Add default image url here
const tangent_default_selfie_image_url="https://file.tangent.ai/quiz-content/merchants/yon-ka-paris-usa/image/23338056806037955-Screenshot%202024-11-27%20at%203.38.57%C3%A2%C2%80%C2%AFPM.png";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const section_basics_container = document.getElementById("section_basics_sub_container");
const section_essentials_container = document.querySelector("#section_essentials_sub_container");
const section_works_container = document.querySelector("#section_works_sub_container");
const tangent_condition_message_popoup = document.querySelector("#tangent-popup-condition-message"); 
const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 
const tangent_client_domain_url = window.location.origin;

let tangent_selected_product_map;
let recommendIDfetch = false;
let tangent_selfie_id;

let default_addToCartText;
let default_addedToCartText;
let default_add_all_to_cart_text;
let out_of_stock_text;
let no_products_found_text;
let tabs_title_mapping;
let condition_text_mapping;

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

let tangent_client_domain_currency;

let isPageLoadCalled = false;

const tangent_shop_iso_code = document.querySelector("#tangent-shop-iso");
setISOBasedTexts(tangent_shop_iso_code.innerHTML);

function setISOBasedTexts(lang_code) {
  const languageMappings = {
    fr: {
      condition_text_mapping: {
        dark_circles: "Sujet aux cernes ici ! Essayez notre <a target='_blank' href='/products/serum-vitamine-c'>Serum Vitamine C</a>.",
        wrinkles: "Ici, sujet aux rides ! Essayez notre <a target='_blank' href='/collections/age-exception/products/revolutionary-anti-aging-excellence-code-creme'>Excellence Code Creme</a>.",
        rosacea: "Sujet à la rosacée ici ! Essayez notre <a target='_blank' href='/products/redness-sensitivity-sensitive-creme-anti-red'>Sensitive Creme Anti-Red</a>.",
        texture: "Enclin à la texture ici ! Essayez notre <a target='_blank' href='/collections/face-anti-aging/products/anti-wrinkles-elastine-jour'>Elastine Jour</a>.",
        darkspots: "Sujet aux points noirs ici ! Essayez notre <a target='_blank' href='/products/serum-vitamine-c'>Serum Vitamine C</a>.",
        acne: "Sujet à l'acné ici ! Essayez notre <a target='_blank' href='/products/acne-juvenil'>Juvenil</a>."
      },
      tabs_title_mapping: {
        section_basics: "Essentiels Ciblés",
        section_essentials: "Routine Complète de Jour",
        section_works: "Collection de Soins Prestige"
      },
      default_addToCartText: "Ajouter au panier",
      default_addedToCartText: "Ajouté au panier !",
      default_add_all_to_cart_text: "Tout ajouter au panier",
      out_of_stock_text: "En rupture de stock",
      no_products_found_text: "Aucun produit trouvé. Veuillez réessayer !"
    },
    de: {
      condition_text_mapping: {
        dark_circles: "Neigen Sie zu dunklen Augenringen? Probieren Sie unser <a target='_blank' href='/products/serum-vitamine-c'>Serum Vitamine C</a>.",
        wrinkles: "Hier sind Sie anfällig für Falten! Probieren Sie unser <a target='_blank' href='/collections/age-exception/products/revolutionary-anti-aging-excellence-code-creme'>Excellence Code Creme</a>.",
        rosacea: "Neigen Sie hier zu Rosazea! Probieren Sie unser <a target='_blank' href='/products/redness-sensitivity-sensitive-creme-anti-red'>Sensitive Creme Anti-Red</a>.",
        texture: "Hier ist Textur angesagt! Probieren Sie unser <a target='_blank' href='/collections/face-anti-aging/products/anti-wrinkles-elastine-jour'>Elastine Jour</a>.",
        darkspots: "Anfällig für dunkle Flecken hier! Probieren Sie unser <a target='_blank' href='/products/serum-vitamine-c'>Serum Vitamine C</a>.",
        acne: "Neigen Sie zu Akne? Probieren Sie unser <a target='_blank' href='/products/acne-juvenil'>Juvenil</a>."
      },
      tabs_title_mapping: {
        section_basics: "Gezielte Essentials",
        section_essentials: "Vollständiger Tagesablauf",
        section_works: "Prestige-Behandlungskollektion"
      },
      default_addToCartText: "In den Warenkorb legen",
      default_addedToCartText: "Zum Warenkorb hinzugefügt!",
      default_add_all_to_cart_text: "Alles in den Warenkorb legen",
      out_of_stock_text: "Nicht vorrätig",
      no_products_found_text: "Keine Produkte gefunden!"
    },
    en: {
      condition_text_mapping: {
        dark_circles: "Prone to dark circles here! Try our <a target='_blank' href='/products/serum-vitamine-c'>Serum Vitamine C</a>.",
        wrinkles: "Prone to wrinkles here! Try our <a target='_blank' href='/collections/age-exception/products/revolutionary-anti-aging-excellence-code-creme'>Excellence Code Creme</a>.",
        rosacea: "Prone to rosacea here! Try our <a target='_blank' href='/products/redness-sensitivity-sensitive-creme-anti-red'>Sensitive Creme Anti-Red</a>.",
        texture: "Prone to texture here! Try our <a target='_blank' href='/collections/face-anti-aging/products/anti-wrinkles-elastine-jour'>Elastine Jour</a>.",
        darkspots: "Prone to darkspots here! Try our <a target='_blank' href='/products/serum-vitamine-c'>Serum Vitamine C</a>.",
        acne: "Prone to acne here! Try our <a target='_blank' href='/products/acne-juvenil'>Juvenil</a>."
      },
      tabs_title_mapping: {
        section_basics: "Targeted Essentials",
        section_essentials: "Complete Day Routine",
        section_works: "Prestige Treatment Collection"
      },
      default_addToCartText: "Add to Cart",
      default_addedToCartText: "Added to Cart!",
      default_add_all_to_cart_text: "Add All to Cart",
      out_of_stock_text: "Out of Stock",
      no_products_found_text: "No products found!"
    }
  };

  // Default to English if the provided lang_code doesn't exist
  const selectedLanguage = languageMappings[lang_code] || languageMappings.en;

  // Assign values
  condition_text_mapping = selectedLanguage.condition_text_mapping;
  tabs_title_mapping = selectedLanguage.tabs_title_mapping;
  default_addToCartText = selectedLanguage.default_addToCartText;
  default_addedToCartText = selectedLanguage.default_addedToCartText;
  default_add_all_to_cart_text = selectedLanguage.default_add_all_to_cart_text;
  out_of_stock_text = selectedLanguage.out_of_stock_text;
  no_products_found_text = selectedLanguage.no_products_found_text;
}


// Use DOMContentLoaded to catch early loading
document.addEventListener("DOMContentLoaded", onLoadFunction);

// Use window.onload to catch full page load (if needed)
window.addEventListener("load", onLoadFunction);

function onLoadFunction(){
  if (!isPageLoadCalled) {
    isPageLoadCalled = true;
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id); 
  }
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    let tangent_recommended_products = response.products;
    let selected_variants_map = response.selected_variants;
    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText+" "; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);
  
    var tangent_product_sections = response.product_sections;
    var tangent_text_sections = response.text_sections;

    createTabButtons();
  
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    
    setTabOpen(response.tags);
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, selected_variants_map);
        enableButtonListener();
        loadElementsOnResponseData();        
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }

    if (response.description == '') {
      setElementDisplayById('tangent-general-text','block');
    }

      // Initialize the tabs
    setupTabs();
}

// Utility function to scroll to a tab
const scrollToTab = (tabsContainer, tabButton) => {
    const position = tabButton.getBoundingClientRect();
    const scroll = tabsContainer.scrollLeft;
    tabsContainer.scrollTo({
        left: scroll + position.left - tabsContainer.offsetLeft - 30,
        behavior: 'smooth',
    });
};

// Utility function to hide all content divs
const hideAllTabContents = () => {
    document.querySelectorAll('.tabcontent').forEach(div => {
        div.style.display = 'none';
    });
};

// Utility function to show the corresponding content
const showTabContent = (tabButton) => {
    const targetDiv = document.querySelector(`#${tabButton.name}_container`);
    if (targetDiv) {
        targetDiv.style.display = 'block';
    }
};

// Utility function to update active class
const updateActiveTab = (tabButtons, activeButton) => {
    tabButtons.forEach(button => button.classList.remove('active'));
    activeButton.classList.add('active');
};

// Main logic for setting up tabs
const setupTabs = () => {
    const tabsContainer = document.querySelector('.tab');
    const tabButtons = document.querySelectorAll('.tab button');

    tabButtons.forEach(tabButton => {
        tabButton.addEventListener('click', function () {
            // Scroll to the clicked tab
            scrollToTab(tabsContainer, this);

            // Hide all content divs and show the corresponding content
            hideAllTabContents();
            showTabContent(this);

            // Update active class for the tabs
            updateActiveTab(tabButtons, this);
        });
    });
};

// Selfie Mapping data api call
function getSelfieMapping(selfie_id){
   var selfie_api_url = "https://service.tangent.ai/shopify/upload-selfie?selfie_id="+selfie_id+"&user=mango" 
   var xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        var DONE =  (typeof XMLHttpRequest.DONE !== 'undefined') ? XMLHttpRequest.DONE : 4;
        if (xmlhttp.readyState == DONE) { 
            if (xmlhttp.status == 200) {
              var response_json = JSON.parse(xmlhttp.responseText);
              tangent_facemap_data = response_json["selfie_record"][0].facemap;
              setScores(tangent_facemap_data.scores);
              
              document.getElementById("tangent_section_selfie_parent_wrapper").classList.add('selfie-section-flow');
              document.querySelector("#canvas_img").setAttribute("src",tangent_facemap_data.url);

              setElementDisplayById('image-parent-container','flex');
              setElementDisplayById('hideHighlight','flex');
              setElementDisplayById('image-loading-section','none');
              
              setElementDisplayById("tangent_score_description","block");
              setElementDisplayById("skin-health-title-container","block");
            }
            else if (xmlhttp.status == 400) {
                console.log('There was an error 400');
            }
            else {
                console.log('Something else other than 200 was returned');
            }
        }
    };

    xmlhttp.open("GET", selfie_api_url, true);
    xmlhttp.send();
}

function setSelfieId(id){
  tangent_selfie_id = id;
}

function getSelfieId(){
  return tangent_selfie_id;
}

function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};
  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    if(section!="section_basics" && section!="section_essentials" && section!="section_works"){
      let basic_product_section_grid = document.getElementById("basic_"+section+"_product_grid");
      let essential_product_section_grid = document.getElementById("essential_"+section+"_product_grid");
      let works_product_section_grid = document.getElementById("work_"+section+"_product_grid");
      
      // Create a document fragment for improved performance
      let basic_fragment = document.createElement('div');
      let essential_fragment = document.createElement('div');
      let work_fragment = document.createElement('div');
      
      product_ids.forEach(id => {
        const product = products.find(p => String(p.id) === id);
        const product_html = getProductHTML(product, products.indexOf(product), section, selected_variants);        
        
        if(basic_product_section_grid){
          basic_product_section_grid.innerHTML = basic_product_section_grid.innerHTML + product_html;
        }
        if(essential_product_section_grid){
          essential_product_section_grid.innerHTML = essential_product_section_grid.innerHTML + product_html;
        }
        if(works_product_section_grid){
          works_product_section_grid.innerHTML = works_product_section_grid.innerHTML + product_html;
        }
      });
      
    }
    else{
      // Added for parent section add all to cart
      product_ids.forEach(id => {
        const product = products.find(p => String(p.id) === id);
        const variant = getVariantOfProduct(product, selected_variants);
        if(isProductAvailable(product, variant)){
          updateSectionAllToCartLink(section, variant);
        }
      });
    }
  });
}

function getVariant(product, variant_id){
  let variant_list = product.variants;
  for (let index = 0; index < variant_list.length; index++) {
    if(variant_list[index].id==variant_id){
      return variant_list[index];
    }
  }
  return null;
}

function getProductHTML(product, index, section, selected_variants) {
  
  let variant = getVariantOfProduct(product, selected_variants);
  
  // Destructuring for clarity
  const { price: productPrice, id: variantId, title: variantTitle, image_id: variantImageId } = variant;
  const { handle: productHandle, title: productTitle } = product;
  
  let addToCartClass="";
  let cartButtonText;
  if(!isProductAvailable(product, variant)){
    cartButtonText = out_of_stock_text;
    addToCartClass="disable-btn-wrapper";
  }
  else{
    cartButtonText = default_addToCartText;
    addToCartClass ="";
  }
  
  // Set URLs and image
  const variantImageUrl = getVariantImage(variantImageId, product);
  const variantProductUrl = `${tangent_client_domain_url}/products/${productHandle}?variant=${variantId}`;

  let variantLabel = "";
  // Determine if variant title is shown
  if(variantTitle!="Default Title"){
    variantLabel = `<br>${variantTitle}`;
  }
  // Product HTML using template literals
  return `
    <div class="tangent-product-item">
      <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variantProductUrl}">
        <img id="image_tangent_product_${index}" src="${variantImageUrl}" class="tangent-product-image" alt="${productTitle}">
        <p class="tangent-product-title tangent-product-title-text">
          <b>${productTitle}</b>${variantLabel}
        </p>
        <p id="price_tangent_product_${index}" class="tangent-product-price-text">
          ${tangent_client_domain_currency}${productPrice}
        </p>
      </a>
      <div id="${section}_variant_${index}" class="tangent-product-variant"></div>
      <p class="tangent-btn-add tangent-add-to-cart-button ${addToCartClass}" id="${section}_cart_tangent_product_${index}_text">
        <a class="tangent-product-add-btn-wrapper" id="${variantId}" href="javascript:void(0)">
          ${cartButtonText}
        </a>
      </p>
    </div>
  `;
}

function getVariantOfProduct(product, selected_variants){
  const products_variant_list = selected_variants[product.id] || [];
  const hasSelectedVariants = products_variant_list.length > 0;
  
  let enable_variant_title = false;
  if(hasSelectedVariants){
    enable_variant_title = true;
    variant = getVariant(product, hasSelectedVariants[0]);
  }
  else{
    variant = product.variants[0];
  }
  
  tangent_selected_product_map[product.id] = variant.id;
  return variant;
}

function isProductAvailable(product, variant) {
  // Check if the product is active
  if (product.status !== "active") {
    return false;
  }

  // Handle inventory policy and management
  const { inventory_policy, inventory_quantity, inventory_management } = variant || {};
  
  // If policy is 'deny', out of stock, and inventory management is enabled
  if (inventory_policy === "deny" && inventory_quantity < 1 && inventory_management) {
    return false;
  }
  
  // Product is available
  return true;
}

function setTabOpen(tags) {
  const tabWrapper = document.querySelector("#tab-wrapper");
  const tabContents = document.querySelectorAll(".tabcontent");
  const tabLinks = document.querySelectorAll(".tablinks");

  // Show tab wrapper
  tabWrapper.style.display = "block";

  // Determine the default tab index based on tags
  let tabIndex = 0;
  if (tags.includes("routine_10_mins")) {
    tabIndex = 1;
  } else if (tags.includes("routine_15_mins")) {
    tabIndex = 2;
  }

  // Hide all tab content and remove 'active' class from all links
  tabContents.forEach(tab => tab.style.display = "none");
  tabLinks.forEach(link => link.classList.remove("active"));

  // Show the appropriate tab content and activate the corresponding tab link
  tabContents[tabIndex].style.display = "flex";
  tabLinks[tabIndex].classList.add("active");
}

function createTabButtons(){
  for (var section in tabs_title_mapping) {
   createTabButton(section)    
  }
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(section, variant){
  let variant_id = variant.id;
  // Create and add all sections cart values to a map
  if (sections_add_to_cart_map[section]) {
    const sectionData = sections_add_to_cart_map[section];
    if (!sectionData.list.includes(variant_id)) {
      sectionData.count++;
      sectionData.cart_link += `&id[]=${variant_id}`;
      sectionData.list.push(variant_id);
    }
    
    document.getElementById(section+"_add_all_cart_link").href=sections_add_to_cart_map[section].cart_link;
  } else {
    sections_add_to_cart_map[section] = {
      count: 1,
      cart_link: `${tangent_client_domain_url}/cart/add?id[]=${variant_id}`,
      list: [variant_id],
    };
  }  
  
}

const getVariantImage = (imageId, product) => {
    var product_image;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    product_image = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            product_image = product.image.src;
        }
        else{
            product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(product_image== undefined || product_image==null){
        product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return product_image;
}

// Add To Cart Function
function addToCart(btn){ 
  let formData = {
   'items': [{
    'id': btn.id,
    'quantity': 1
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if(btn!=undefined){
      btn.innerHTML = default_addedToCartText;
      btn.classList.add("added-to-cart-style"); 
    }    
    document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
    document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    })); 
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    return section_container;
}

// Add to cart button for sections
function createSectionAddAllToCart(section_name) {

    var add_all_cart_link = document.createElement("a");
    add_all_cart_link.id = section_name+"_add_all_cart_link";
    add_all_cart_link.classList.add("section_add_all_cart_link");
    add_all_cart_link.classList.add(section_name+"_add_all_cart_link");
    add_all_cart_link.href="#";
    var add_all_to_cart_p_tag = document.createElement("p");
    add_all_to_cart_p_tag.id = section_name+"_add_all_to_cart";
    add_all_to_cart_p_tag.classList.add("section_add_all_to_cart");
    add_all_to_cart_p_tag.classList.add(section_name+"_add_all_to_cart");
    add_all_to_cart_p_tag.innerHTML = default_add_all_to_cart_text;
  
    add_all_cart_link.appendChild(add_all_to_cart_p_tag);
    return add_all_cart_link;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Tab buttons 
function createTabButton(section_name) {
    var tab_button = document.createElement("button");
    tab_button.id = section_name+"_tab_button";
    tab_button.innerHTML = getTabTitle(section_name);
    tab_button.name = section_name;
    tab_button.classList.add("tablinks");
    tangent_custom_tabs.appendChild(tab_button);
}

function getTabTitle(section){
  var tab_title;
  if(tabs_title_mapping[section]!=undefined){
    tab_title = tabs_title_mapping[section];
  }
  else{
    tab_title = section.replace("section_","").replace("_"," ").toUpperCase();
  }
  return tab_title;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      if(section_name!="section_basics" && section_name!="section_essentials" && section_name!="section_works"){
        // The created container will have both a container to show text and products
        var section_container = createSectionContainer(section_name);    
        
        // Creating text sections before products sections if exists
        if(text_sections!=undefined){
            createTextSectionBeforeProducts(text_sections,section_container,section_name);
        }    
        
        // Creating section to add all products
        section_container.appendChild(addSectionProductGridContainer(section_name));
    
        // Creating add all to cart button for the section    
        // section_container.appendChild(createSectionAddAllToCart(section_name));
  
        const basic_list = ["serum","moisturizer"];
        const essential_list = ["cleanser","toner","serum","moisturizer"];
        const work_list = ["cleanser","toner","exfoliator","serum","moisturizer","mask","specific"];
        if (basic_list.includes(section_name)) {
          addToTab(section_container, "basic", section_basics_container);
        }
        if (essential_list.includes(section_name)) {
          addToTab(section_container, "essential", section_essentials_container);
        }
        if (work_list.includes(section_name)) {
          addToTab(section_container, "work", section_works_container);
        }
      }
      else{
        let addAllToCart = createSectionAddAllToCart(section_name);
        
        if(section_name=="section_basics"){
          document.getElementById("section_basics_container").appendChild(addAllToCart);
        }
        else if(section_name=="section_essentials"){
          document.getElementById("section_essentials_container").appendChild(addAllToCart); 
        }
        else{
          document.getElementById("section_works_container").appendChild(addAllToCart);
        }
      }
    }
}

function addToTab(container, prefix, destination) {
  let clonedContainer = container.cloneNode(true);
  clonedContainer.children[1].id = `${prefix}_${clonedContainer.children[1].id}`;
  destination.appendChild(clonedContainer);
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_container.classList.remove('tabcontent');   
              section_selfie.appendChild(section_container);
            }
            else if(section_name == "section_additional_content"){
              var section_additional = document.querySelector("#section_additional_content_container_parent");
              section_container.classList.remove('tabcontent');   
              section_additional.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              // tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

const setElementDisplayById = (elementId, displayStyle) => {
  document.getElementById(elementId).style.display=displayStyle;
}

// Getting current canvas click position
function getCursorPosition(canvas, event) {

  const ctx = canvas.getContext( '2d' );
  const bb = canvas.getBoundingClientRect();
  var point = {
    _x:Math.floor((event.clientX - bb.left) / bb.width * canvas.width),
    _y:Math.floor((event.clientY - bb.top) / bb.height * canvas.height)
  }

  var skin_conditions = ["acne","darkspots","wrinkles","dark_circles","rosacea"];
  var click_found = false;
  for(var sc=0;sc <skin_conditions.length;sc++){
    if(isPointInsidePoligon(point,tangent_facemap_data[skin_conditions[sc]])){
      openConditionMessage(canvas,skin_conditions[sc]);
      click_found=true;
      break;
    }
  }
  if(!click_found){
    tangent_condition_message_popoup.style.display="none";
    console.log("no condition click");
  }
}

function openConditionMessage(canvas,condition){
  tangent_condition_message_popoup.innerHTML = condition_text_mapping[condition];
  let rect = canvas.getBoundingClientRect();
  var point = {
    _x:event.clientX - rect.left,
    _y:event.clientY - rect.top
  }
  
  // Positioning Popup
  Object.assign(
    tangent_condition_message_popoup.style,
    {
      display:"block",
      left:(point._x) +"px",
      top:(point._y) +"px"
    }
  );
}

// Check whether click is inside condition points
function  isPointInsidePoligon(pt, points_list) {
  // https://stackoverflow.com/a/29915728/960654
  // ray-casting algorithm based on
  // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html
    
  var x = pt._x,
    y = pt._y

  var inside = false;
  for(var c=0;c<points_list.length;c++){
    var points = points_list[c];
    for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
      var xi = points[i][0],
        yi = points[i][1]
      var xj = points[j][0],
        yj = points[j][1]

      var intersect =
        yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
      if (intersect) inside = !inside
    }
  }
  return inside
}


// Toggle hide highlight and show highlight
function toggleHighlight(status){
  if(status){
    setElementDisplayById('image-parent-container','block');
    setElementDisplayById('hideHighlight','block');
    setElementDisplayById('showHighlight','none');
    setElementDisplayById('selfie_canvas','block');
  }
  else{
    setElementDisplayById('hideHighlight','none');
    setElementDisplayById('showHighlight','block');
    setElementDisplayById('selfie_canvas','none');
  }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
  const canvasImg = document.querySelector('#canvas_img');
  setElementDisplayById('canvas_img','block');
  if(response.selfie_url!=undefined && response.selfie_url!=null){
    setSelfieId(response["selfie_id"]);
    getSelfieMapping(response["selfie_id"]);
    if (canvasImg) {
        canvasImg.src = response.selfie_url;
    }
  }
  else{
    if(tangent_default_selfie_image_url!=""){
      setElementDisplayById('image-loading-section','none');
      if (canvasImg) {
        canvasImg.src = tangent_default_selfie_image_url;
      }
    }
    else{
      setElementDisplayById('image-loading-section','none');
      setElementDisplayById("tangent_selfie_container","none");
    }
  }    
}

// Enabling button listeners
function enableButtonListener() {
  // Listener for "Add to Cart" buttons
  const allBtns = document.querySelectorAll('.tangent-product-add-btn-wrapper');
  
  allBtns.forEach(button => {
    button.addEventListener('click', function(event) {
      addToCart(this);
    }, false);
  });
}

const loadElementsOnResponseData = () => {
    const allElements = document.querySelectorAll('.load-on-data');
    allElements.forEach(element => {
        element.style.display = "block";
    });
};


// Setting scores below the selfie
const setScores = (scores) => {
    let scoresPresent = false;
    let concernCount = 0;

    const scoreContainers = {
        acne: "Acne_Score",
        rosacea: "Rosacea_Score",
        darkspots: "DarkSpots_Score",
        wrinkles: "Wrinkles_Score",
        dark_circles: "DarkCircles_Score",
        texture: "Texture_Score",
    };

    Object.keys(scores).forEach(key => {
        if (scoreContainers[key]) {
            const containerId = `${scoreContainers[key]}_container`;
            const scoreId = `${scoreContainers[key]}`;
            
            // Update container display and score
            document.querySelector(`#${containerId}`).style.display = "flex";
            document.querySelector(`#${scoreId}`).innerHTML = scores[key];
            
            scoresPresent = true;
            concernCount++;
        }
    });

    // Show the overall container if any scores are present
    if (scoresPresent) {
        document.querySelector("#facemap_all_scores_container").style.display = "flex";
    }
};


// Called on image on load function
const drawOnCanvas = () => {
    if(getSelfieId()!=null){
      
      var selfie_canvas = document.querySelector('#selfie_canvas');
      var selfie_canvas_ctx = selfie_canvas.getContext('2d');
      
      selfie_canvas.addEventListener('click', function(e) {
          getCursorPosition(selfie_canvas, e)
      });
      
      var canvas_img = document.querySelector('#canvas_img');
      setCanvasDimensions(selfie_canvas, canvas_img);
      
      var prop = getImageSize(canvas_img.naturalWidth);
      if(tangent_facemap_data){
        drawDarkCircleContours(selfie_canvas_ctx, tangent_facemap_data["dark_circles"], getDarkCircleBlur(prop));
        drawWrinkleContours(selfie_canvas_ctx, tangent_facemap_data["wrinkles"], getWrinkleLineWidth(prop));
        drawRosaceaContours(selfie_canvas_ctx, tangent_facemap_data["rosacea"], getRosaceaBlur(prop));
        drawTextureContours(selfie_canvas_ctx, tangent_facemap_data["texture"], getTextureLineWidth(prop));
        drawDarkSpotsContours(selfie_canvas_ctx, tangent_facemap_data["darkspots"], getDarkSpotsLineWidth(prop));
        drawAcneContours(selfie_canvas_ctx, tangent_facemap_data["acne"],getAcneLineWidth(prop));
      }
    }
}

const setCanvasDimensions = (selfie_canvas, canvas_img) => {
  selfie_canvas.width  = canvas_img.naturalWidth;
  selfie_canvas.height = canvas_img.naturalHeight;
}

const getImageSize = (imgWidth) => {
  var prop =  imgWidth/400;
  return prop;
}

const getDarkCircleBlur = (prop) => {
  if(prop<1){
    return 'blur(1px)';
  }
  else if(prop<1.5){
    return 'blur(2px)';
  }
  else if(prop<2){
    return 'blur(4px)';
  }
  else if(prop<3){
    return 'blur(7px)';
  }
  else if(prop<4){
    return 'blur(12px)';
  }
  else{
    
  }
}

const getRosaceaBlur = (prop) => {
  if(prop<1){
    return 'blur(4px)';
  }
  else if(prop<1.5){
    return 'blur(4px)';
  }
  else if(prop<2){
    return 'blur(5px)';
  }
  else if(prop<3){
    return 'blur(13px)';
  }
  else if(prop<4){
    return 'blur(18px)';
  }
  else{
    console.log("out of bound props - Rosacea");
  }
}

const getAcneLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 7;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - Acne");    
  }
}

const getDarkSpotsLineWidth = (prop) => {
  if(prop<1){
    return 1;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 6;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - DarkSpots");    
  }
}

const getTextureLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 3;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 16;
  }
  else{
    return 20;
  }
}

const getWrinkleLineWidth = (prop) => {
  if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 15;
  }
  else if(prop<4){
    return 30;
  }
  else{
    console.log("out of bound props - Wrinkle");    
  }
}

const drawDarkCircleContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(28, 30, 82, 0.3)';
  drawContours(context, eye_contours, true, false);
}

const drawWrinkleContours = (context, wrinkle_contours, lineWidth) => {
  context.fillStyle = 'rgba(24, 96, 3, 0.5)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(24, 96, 3, 0.5)";
  drawContours(context, wrinkle_contours, true, true);
}

const drawRosaceaContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(206, 66, 66, 0.5)';
  drawContours(context, eye_contours, true, false);
}

const drawTextureContours = (context, eye_contours, lineWidth) => {
  context.lineWidth = lineWidth;
  context.filter = 'none';
  context.strokeStyle = "rgba(186, 111, 223, 0.5)";
  drawContours(context, eye_contours, false, true);
}

const drawDarkSpotsContours = (context, darkspots_contours, lineWidth) => {
  context.fillStyle = 'rgba(81, 212, 191, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(81, 212, 191, 0.4)";
  drawContours(context, darkspots_contours, true, false);
}

const drawAcneContours = (context, acne_contours, lineWidth) => {
  context.fillStyle = 'rgba(234, 220, 96, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(234, 220, 96, 0.4)";
  drawContours(context, acne_contours, true, false);
}

const drawContours = (context, contours, fill, stroke) => {
  for (let i = 0; i < contours.length; i++) {
    drawContour(context, contours[i], fill, stroke)
  }
}

const drawContour = (context, contour_coordinates, fill=false, stroke=false) => {
  context.beginPath();
  for (let i = 0; i < contour_coordinates.length; i++) {
    let point = contour_coordinates[i]
    if (i == 0) {
      context.moveTo(point[0], point[1]);
    } else {
      context.lineTo(point[0], point[1]);
    }
  }
  context.closePath();
  if (fill) context.fill();
  if (stroke) context.stroke();
}
